import {useQuery} from "@tanstack/react-query";
import DispatchInfoService from "../../../services/reports/dispatch-info-service.js";
import {useSearchParams} from "react-router";
import {useRef, useState} from "react";
import {Template} from "../../../components/template/template.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import Content from "./components/content.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";
import PrintOptionsModal from "../../../components/print-options-modal/print-options-modal.jsx";

const printFields = [
    {
        title: "Solicitantes",
        options: [
            {
                key: "showRequesters",
                label: "Exibir solicitantes na impressão",
            }
        ],
    },
    {
        title: "Anexos",
        options: [
            {
                key: "showImages",
                label: "Exibir imagens na impressão",
            },
            {
                key: "attachFullSize",
                label: "Imprimir um anexo por folha",
                disabled: (options) => !options.showImages,
            },
        ],
    },
];

const initialPrintOptions = Object.fromEntries(
    printFields.flatMap((group) =>
        group.options.map((item) => [item.key, false])
    )
);

export default function DispatchInfo() {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("id");
    const [headerSelected, setHeaderSelected] = useState(-1);
    const [isPrinting, setIsPrinting] = useState(false);
    const [printModal, setPrintModal] = useState(false);
    const [printOptions, setPrintOptions] = useState(initialPrintOptions);
    const printComponentRef = useRef(null);
    const title = "Informações do despacho";

    const { data: reportDispatch, isLoading: isLoadingReport } = useQuery({
        queryKey: ["dispatch-info", id],
        queryFn: () => DispatchInfoService.getDispatch(id),
        enabled: !!id,
    });

    const boName = reportDispatch?.dispatch?.boName;
    const printItems = printFields;
    const hasData = !!(reportDispatch?.dispatch && Object.keys(reportDispatch?.dispatch).length > 0);

    return (
        <>
            <Template isLoading={isLoadingReport || isPrinting}>
                <Template.Header>
                    <Template.Title>{title}</Template.Title>
                    <HeaderButtons
                        printOptions={true}
                        printable={true}
                        setPrintModal={setPrintModal}
                        printComponentRef={printComponentRef}
                        reportData={reportDispatch}
                        data={hasData}
                        headerChange={true}
                        headerSelected={headerSelected}
                        setHeaderSelected={setHeaderSelected}
                    />
                </Template.Header>
                <Template.Body className="pl-0!">
                    <Card className="w-full max-w-[1030px] mx-auto p-[0]!">
                        <Card.Body>
                            <NoDataContent reportData={reportDispatch} data={hasData} />
                            <Content
                                id={id}
                                reportData={reportDispatch}
                                data={hasData}
                                entity={headerSelected}
                                title={title}
                                printComponentRef={printComponentRef}
                                setIsPrinting={setIsPrinting}
                                printOptions={printOptions}
                                boName={boName}
                            />
                        </Card.Body>
                    </Card>
                </Template.Body>
            </Template>

            <PrintOptionsModal
                open={printModal}
                setOpen={setPrintModal}
                printRef={printComponentRef}
                options={printOptions}
                setOptions={setPrintOptions}
                items={printItems}
            />
        </>
    )
}